import Button from "../../../../common/Button";
import FootprintList from "../../FootprintList";
import { useState } from "react";
import useAddFootprintPartAssociation from "../../../../../utils/hooks/footprints/addAssociation";
import LoadingOverlay from "../../../../LoadingOverlay";

export default function AddExistingFootprint({
  partId,
  onAdd,
}: {
  partId: string;
  onAdd: () => void;
}) {
  const { adding, addFootprintPartAssociation } =
    useAddFootprintPartAssociation(partId, onAdd);
  const [selectedFootprintId, setSelectedFootprintId] = useState<string | null>(
    null,
  );

  const handleAddAssociation = () => {
    if (selectedFootprintId !== null) {
      addFootprintPartAssociation(selectedFootprintId, partId);
    }
  };

  return (
    <>
      <LoadingOverlay loading={adding} text={"Adding association..."} />
      <FootprintList
        selectedFootprintId={selectedFootprintId}
        setSelectedFootprintId={setSelectedFootprintId}
      />
      <Button
        label={"Add"}
        onClick={handleAddAssociation}
        disabled={selectedFootprintId === null}
      />
    </>
  );
}
